<style lang="scss" scoped>
.pointer {
  text-decoration: underline;
  color: blue;
  .text {
    text-align: center;
  }
}
</style>

<template>
  <v-layout row wrap>
    <v-flex xs12>
      <h2 class="text-center my-2">{{ content.title }}</h2>
    </v-flex>

    <v-flex xs12>
      <v-layout row wrap justify-center>
        <v-flex xs12 lg8 xl8 class="mt-2">
          <template v-if="devices">
            <div class="table">
              <v-data-table
                :options.sync="pagination"
                :loading="loading"
                :headers="headers"
                :items="notifications"
                :server-items-length="total"
                :items-per-page="perPage"
                :no-data-text="''"
                :no-results-text="content.noresults"
                :footer-props="{
                  'items-per-page-text': content.footer.rowsperpage,
                  'items-per-page-all-text': content.all,
                }"
                locale="he"
                class="elevation-1"
                disable-sort
              >
                <template v-slot:headers="props">
                  <tr v-if="$vuetify.breakpoint.smAndUp">
                    <th
                      v-for="header in props.headers"
                      :key="header.text"
                      :class="textdir"
                    >
                      {{ header.text }}
                    </th>
                  </tr>
                  <tr v-else>
                    <th
                      v-for="header in XSheaders"
                      :key="header.text"
                      :class="textdir"
                    >
                      {{ header.text }}
                    </th>
                  </tr>
                </template>
                <template v-if="$vuetify.breakpoint.xsOnly" v-slot:items="nots">
                  <td class="px-1">{{ nots.item.created_at }}</td>
                  <td
                    v-if="nots.item.device_name || nots.item.gateway_name"
                    class="tableData px-1"
                  >
                    {{
                      nots.item.device_name
                        ? nots.item.device_name
                        : nots.item.gateway_name
                    }}<br /><small>{{
                      nots.item.device_identifier
                        ? nots.item.device_identifier
                        : nots.item.gateway_identifier
                    }}</small>
                  </td>
                  <td v-else class="px-1 orange--text text--darken-4">
                    {{ content.notowned }}
                  </td>
                  <td class="tableData px-1">{{ nots.item.msg_title }}</td>
                </template>
                <template v-else v-slot:items="nots">
                  <td class="tableData">
                    {{ nots.item.created_at }}
                  </td>
                  <td
                    class="tableData"
                    v-if="nots.item.device_name || nots.item.gateway_name"
                  >
                    {{
                      nots.item.device_name
                        ? nots.item.device_name
                        : nots.item.gateway_name
                    }}
                  </td>
                  <td v-else class="orange--text text--darken-4">
                    {{ content.notowned }}
                  </td>
                  <td class="tableData">
                    {{ content.type[nots.item.type] }}
                  </td>
                </template>
                <template v-slot:[`item.actions`]="{ item }">
                  <td
                    class="pointer"
                    :style="{
                      width: $vuetify.breakpoint.xsOnly ? '100vw' : '',
                    }"
                    @click="
                      item.device_slug || item.gateway_identifier
                        ? item.device_slug
                          ? onRowClick(item.device_slug)
                          : onRowClickGateway(item.gateway_identifier)
                        : null
                    "
                  >
                    <div
                      class="text"
                      v-if="item.device_slug || item.gateway_identifier"
                    >
                      {{ content.headers.goto }}
                    </div>
                  </td>
                </template>
                <template v-slot:[`footer.page-text`]="items">
                  {{ items.pageStart }} - {{ items.pageStop }}
                  {{ content.footer.of }} {{ items.itemsLength }}
                </template>
              </v-data-table>
            </div>
          </template>
        </v-flex>
      </v-layout>
    </v-flex>
  </v-layout>
</template>

<script>
import Lang from "@/helpers/lang";
import dayjs from "@/plugins/dayjs";
export default {
  data() {
    return {
      locale: null,
      loading: true,
      content: {},
      textdir: null,
    };
  },
  created() {
    this.locale = Lang.get();
    this.setLang();
    this.notifications;
    this.textdir = this.locale == "he" ? "text-right" : "text-left";
    this.setHeaders();
  },
  watch: {
    notifications() {
      this.loading = false;
    },
  },
  mounted() {},
  computed: {
    time(val) {
      // console.log(val);
      return val;
    },
    devices() {
      return this.$store.getters["devices/alldevices"];
    },
    gateways() {
      return this.$store.getters["gateways/gateways"];
    },
    user() {
      return this.$store.getters["user/user"];
    },
    notifications() {
      const DEVICES = this.devices;
      const GATEWAYS = this.gateways;
      const notifications = JSON.parse(
        JSON.stringify(this.$store.getters["notifications/notifications"])
      );
      return notifications.map((not) => {
        // console.log("not111111111111111111111111111111: ", not);
        let gateway = Object.values(GATEWAYS).filter(
          (g) => g.slug == not.gateway_identifier
        )[0];
        if (DEVICES[not.device_identifier]) {
          not.device_slug = DEVICES[not.device_identifier].slug;
        }
        if (gateway) {
          not.gateway_identifier = gateway.mac;
          not.gateway_slug = gateway.slug;
          if (not.gateway_name) {
            not.gateway_name = gateway.names.length
              ? gateway.names.filter((g) => g.user == this.user.slug)[0].name
              : gateway.mac;
          }

          // not.created_at = dayjs(not.created_at).format("DD/MM/YY - HH:mm");
          // not.read_at = dayjs(not.read_at).format("DD/MM/YY - HH:mm");
        }
        if (DEVICES[not.device_identifier]) {
          not.device_name = DEVICES[not.device_identifier].name;
          not.device_identifier = DEVICES[not.device_identifier].identifier;
          // not.created_at = dayjs(not.created_at).format("DD/MM/YY - HH:mm");
          // not.read_at = dayjs(not.read_at).format("DD/MM/YY - HH:mm");
        }
        if (not.device_name || not.gateway_name) {
          not.name = not.device_name ? not.device_name : not.gateway_name;
        }
        if (not.created_at) {
          not.created_at = dayjs(not.created_at).format("DD/MM/YY - HH:mm");
          not.read_at = dayjs(not.read_at).format("DD/MM/YY - HH:mm");
        }
        // console.log("not222222222: ", not);
        return not;
      });
      // .filter((not) => {
      //   return not.name;
      // });
    },
    total() {
      return this.$store.getters["notifications/total"];
    },
    perPage() {
      let defaultPc = 15;
      let items = this.$store.getters["notifications/perPage"];
      if (this.$vuetify.breakpoint.mdAndUp) {
        items = defaultPc;
      }
      return items;
    },
    pagination: {
      get: function () {
        return this.$store.getters["notifications/pagination"];
      },
      set: function (value) {
        this.loading = true;
        this.$store.dispatch("notifications/fetchNotifications", value);
      },
    },
  },
  methods: {
    onRowClick(item) {
      this.$router.push(`/devices/${item}`);
    },
    onRowClickGateway(item) {
      this.$router.push(`/gateways/${item}`);
    },
    setHeaders() {
      this.XSheaders = [
        {
          text: this.content.headers.time,
          value: "created_at",
          sortable: false,
        },
        {
          text: this.content.headers.name,
          value: "name",
          sortable: false,
        },
        { text: this.content.headers.not, value: "msg_title", sortable: false },
        {
          text: "",
          value: "actions",
          sortable: false,
        },
      ];
      this.headers = [
        {
          text: this.content.headers.time,
          value: "created_at",
          sortable: false,
        },
        {
          text: this.content.headers.name,
          value: "name",
          sortable: false,
        },
        { text: this.content.headers.not, value: "msg_body", sortable: false },
        {
          text: "",
          value: "actions",
          sortable: false,
        },
      ];
    },
    setLang() {
      if (this.locale == "en") {
        this.content = {
          title: "Notifications History",
          footer: {
            of: "of",
            rowsperpage: "Rows per page",
          },
          all: "ALL",
          noresults: "No Notifications Found",
          notowned: "Not owned anymore",
          nodevice: "No such device",
          sortBy: "Sort by",
          headers: {
            time: "Notified At",
            short_time: "Time",
            name: "Device Name",
            device: "Device",
            identifier: "Device Identifier",
            not: "Notification",
            read: "Read At",
            goto: "Go To",
          },
          type: {
            NotConnected: "Lost power or internet connection",
            IsConnected: "The power or internet connection is back",
            NoSensor: "The sensor has disconnected",
            ForbiddenArea: "Is in a forbidden area",
            MetTreshold: "Reached the threshold you set",
            FixedMetTreshold: "The indicators returned to normal",
            FloodSuspected: "The buoy identifies flooding",
            FloodFixed: "The buoy is back to normal",
            DoorOpened: "The sensor detected a door opening",
            DoorClosed: "The sensor detected a door closing",
            SmokeAlarm: "Warning of smoke!",
            MotionDetected: "Detects motion!",
            LowBattery: "The device has low battery",
          },
        };
      } else if (this.locale == "he") {
        this.content = {
          title: "היסטוריית התראות",
          footer: {
            of: "מתוך",
            rowsperpage: "שורות בעמוד",
          },
          all: "הכל",
          noresults: "לא נמצאו התראות",
          notowned: "כבר לא בבעלות",
          nodevice: "המכשיר אינו קיים ",
          sortBy: "סינון לפי",
          headers: {
            time: "זמן ההתראה",
            short_time: "זמן",
            name: "שם מכשיר",
            device: "מכשיר",
            identifier: "מזהה מכשיר",
            not: "התראה",
            read: "זמן קריאה",
            goto: "למעבר למכשיר",
          },
          type: {
            NotConnected: "איבד חיבור לחשמל או לאינטרנט",
            IsConnected: "חזר החיבור לחשמל או לאינטרנט",
            NoSensor: "החיישן לא מחובר",
            ForbiddenArea: "נמצא באזור אסור",
            MetTreshold: "הגיע לסף שהגדרת",
            FixedMetTreshold: "המדדים חזרו למצב תקין",
            FloodSuspected: "המצוף מזהה הצפה",
            FloodFixed: "המצוף חזר למצב תקין",
            DoorOpened: "החיישן מזהה פתיחה של דלת",
            DoorClosed: "החיישן מזהה סגירה של דלת",
            SmokeAlarm: "אזהרת עשן!",
            MotionDetected: "מזהה תנועה!",
            LowBattery: "למכשיר יש סוללה חלשה",
          },
        };
      }
    },
  },
};
</script>
